"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FeedbackCopy_1 = __importDefault(require("./FeedbackCopy"));
exports.default = [
    {
        question: FeedbackCopy_1.default.Satisfaction,
        inputType: "numeric",
        scale: {
            min: {
                value: 1,
                label: FeedbackCopy_1.default.Dissatisfied,
            },
            max: {
                value: 7,
                label: FeedbackCopy_1.default.Satisfied,
            },
        },
        optional: false,
    },
    {
        question: FeedbackCopy_1.default.NPS,
        inputType: "numeric",
        scale: {
            min: {
                value: 0,
                label: FeedbackCopy_1.default.NotLikely,
            },
            max: {
                value: 10,
                label: FeedbackCopy_1.default.VeryLikely,
            },
        },
        optional: false,
    },
    {
        question: FeedbackCopy_1.default.FreeText,
        inputType: "text",
        optional: true,
    },
];
//# sourceMappingURL=feedbackQuestions.js.map